export const categories = [
  {
    id: "shoes",
    name: "Shoes",
    namePt: "Calçados",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    imageQuery: "Stylish%20sneakers%20on%20minimal%20white%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20cream%20backdrop%2C%20editorial%20ecommerce%20style%2C%20modern%20fashion%20aesthetic%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePt: "Moletons/Suéteres",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageSeq: "cat-hoodies-02",
    imageQuery: "Premium%20hoodie%20sweatshirt%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20streetwear%20aesthetic%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePt: "Camisetas",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageSeq: "cat-tshirts-03",
    imageQuery: "Premium%20cotton%20t-shirt%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20modern%20casual%20fashion%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "jackets",
    name: "Jackets",
    namePt: "Jaquetas",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageSeq: "cat-jackets-04",
    imageQuery: "Stylish%20bomber%20jacket%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20outerwear%20fashion%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageSeq: "cat-pants-05",
    imageQuery: "Trendy%20cargo%20pants%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20modern%20streetwear%20fashion%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "headwear",
    name: "Headwear",
    namePt: "Acessórios de Cabeça",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageSeq: "cat-headwear-06",
    imageQuery: "Trendy%20cap%20hat%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20streetwear%20accessory%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "sets",
    name: "Sets",
    namePt: "Conjuntos",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageSeq: "cat-sets-07",
    imageQuery: "Matching%20fashion%20set%20outfit%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20modern%20coordinated%20fashion%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageSeq: "cat-underwear-08",
    imageQuery: "Premium%20underwear%20basics%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20essentials%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "jersey",
    name: "Jersey",
    namePt: "Camisas Esportivas",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageSeq: "cat-jersey-09",
    imageQuery: "Sports%20jersey%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20modern%20athletic%20wear%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "accessories",
    name: "Accessories",
    namePt: "Acessórios",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageSeq: "cat-accessories-10",
    imageQuery: "Fashion%20accessories%20collection%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20accessories%20display%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "bags",
    name: "Bags",
    namePt: "Bolsas",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageSeq: "cat-bags-11",
    imageQuery: "Stylish%20bag%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20modern%20fashion%20bag%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "belts",
    name: "Belts",
    namePt: "Cintos",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageSeq: "cat-belts-12",
    imageQuery: "Premium%20leather%20belt%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20modern%20accessory%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePt: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageSeq: "cat-perfumes-13",
    imageQuery: "Elegant%20perfume%20bottle%20on%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20luxury%20fragrance%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20harmonious%20composition"
  },
  {
    id: "other",
    name: "Other Stuff",
    namePt: "Outros Itens",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageSeq: "cat-other-14",
    imageQuery: "Various%20fashion%20items%20collection%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20miscellaneous%20fashion%20accessories%2C%20editorial%20style%2C%20high%20detail%2C%20soft%20shadows%2C%20elegant%20composition"
  }
];